import React,{useEffect, useLayoutEffect, useRef, useCallback, useState} from 'react'
// import * as THREE from 'three'
// import {Text, Line} from '@react-three/drei'
import '../App.css'
// import useInputStore from '../store/inputStore'
import useProfileStore from '../store/profileStore'
import useDragLineStore from '../store/dragLineStore'
import Angle from './Angle'
// import useHover from '../utils/useHover'
import Segment from './Segment'

export default function Profile() {
  const selectedPts = useProfileStore(state => state.selectedPts)
  const dragMode = useDragLineStore(state => state.dragMode)
  const setTotalLength = useProfileStore(state => state.setTotalLength)
  const totalLength = useProfileStore(state => state.totalLength)
  const lengthRef = useRef(0)

  useEffect(() => {
    setTotalLength(0)
  },[])

  // useEffect(() => {

  // }, [selectedPts])
  // useEffect(() => {
  //   setTotalLength(0)
  // },)

  // const Segment = ({startPt, endPt, order}) => {
  //   const setEditMode = useInputStore(state => state.setEditMode)
  //   const setText = useInputStore(state => state.setText)
  //   const setPosition = useInputStore(state => state.setPosition)
  //   const setIndex = useInputStore(state => state.setIndex)
  //   const setType = useInputStore(state => state.setType)
  //   const [segmentLength, setSegmentLength] = useState(0)
  //   const textRef = useRef()
  //   const [bindHover, hovered] = useHover()

  //   const placeText = useCallback(()=> {
  //     let midpt_x = (startPt[0]+ endPt[0])/2
  //     let midpt_y = (startPt[1]+endPt[1])/2
  //     let normalized_ortho_dir = new THREE.Vector3(endPt[1] - startPt[1], startPt[0] - endPt[0], 0).normalize();
  //     textRef.current.position.x = midpt_x - normalized_ortho_dir.x * 10
  //     textRef.current.position.y = midpt_y - normalized_ortho_dir.y * 10 
  //     textRef.current.position.z = 0
  //     console.log('normalized', normalized_ortho_dir)
  //   },[startPt, endPt])

  //   const changeEditMode = (e) => {
      
  //     e.stopPropagation()
  //     console.log('Change Edit')
  //     if (!dragMode){
  //       setEditMode(true)
  //       if (e.object._private_text){
  //         //Set required data for editing of text
  //         setText(e.object._private_text)
  //         // setAttributes({ position:e.point.toArray(), index:order })
  //         setPosition(e.point.toArray())
  //         setType('length')
  //         setIndex(order)
  //       }
  //       console.log('private text', e.object._private_text )
  //     }

  //   }

  //   const calcLength = useCallback(() => {
  //     //Calculate length of segment
  //     const len = (Math.sqrt(Math.pow((startPt[0] - endPt[0]),2) + Math.pow((startPt[1] - endPt[1]),2))).toFixed(0)
  //     setSegmentLength(len)

  //     lengthRef.current += parseInt(len)
  //   }, [startPt, endPt])
    
  //   useLayoutEffect(()=>{
  //     calcLength();
  //     placeText();
  //     // setTotalLength(lengthRef.current)
  //     //Calculate total length of the profile
  //     console.log('total Len', lengthRef.current)

  //   },[placeText, calcLength])

  //   useEffect(() => {
  //     setTotalLength(0)
  //   },[])

  //   return(
  //     <>
  //       <Line
  //         points={selectedPts}
  //         color="#666666"
  //         linewidth={3}
  //       />
  //         <Text
  //           onDoubleClick={changeEditMode}
  //           {...bindHover}
  //           ref={textRef}
  //           scale={[0.3,0.3,0.3]}
  //           color={hovered ? '#027DC3':'black'}
  //           anchorX="center"
  //           anchorY="middle"
  //           maxWidth={200}
  //           lineHeight={1}
  //           fontSize = {30}
  //           font="https://fonts.gstatic.com/s/raleway/v14/1Ptrg8zYS_SKggPNwK4vaqI.woff"
  //           letterSpacing={0.02}
  //           textAlign={'right'}
  //         >
  //           {segmentLength}
  //         </Text>
  //     </>
  //   )
  // }

  const calcLength = ((pt1, pt2) => {
    console.log('pt1', pt1)
    console.log('pt2', pt2)
    const len = (Math.sqrt(Math.pow((pt1[0] - pt2[0]),2) + Math.pow((pt1[1] - pt2[1]),2))).toFixed(0)
    // setTotalLength(totalLength+ parseInt(len))
    // console.log('totalLen',totalLength)
    return parseInt(len)
  })

  useLayoutEffect(() => {
    let tmpLen = 0
    selectedPts.map((point, index) =>{
      if(index>0){
        tmpLen += calcLength(selectedPts[index-1], selectedPts[index])
      }
    })
    setTotalLength(tmpLen)
  },[selectedPts])

  return(
      <>

        { selectedPts.length &&
          selectedPts.map((point, index) =>{
            if(index > 0){
              return (
                <Segment 
                  key={index} 
                  startPt={selectedPts[index-1]} 
                  endPt={selectedPts[index]} 
                  // len={() => calcLength(selectedPts[index-1], selectedPts[index])} 
                  order={index}/>
              )
          }})
        }
        { (selectedPts.length > 2) && 
          selectedPts.map((point, index) => {
            if (index > 0 && index < selectedPts.length - 1){
              return (
                <Angle key={index} pt1={selectedPts[index -1]} pt2={selectedPts[index]} pt3={selectedPts[index+1]} order={index} />
              )
            }
          })

        }
      </>
  )
}